module.exports = __webpack_public_path__ + "images/Dots.708b4e04c3d7b9d00c4426a2591ddf6a.svg";